module.exports = __webpack_public_path__ + "img/google.c16e3a9d.webp";